let baseUrl = window.location.protocol+'//'+window.location.host;
let domainName = ((window.location.hostname).split("."))[0];
let devHost = 'localhost:6200';
// Cloud front cdn
// Staging
// let bkcdn = 'https://d1k1uzhv0gy2ld.cloudfront.net';
// Live
let bkcdn = 'https://dp3d2hb4975es.cloudfront.net';
if(window.location.host === devHost || window.location.host === "192.168.29.4:4200"){
	domainName = 'sstest';
	baseUrl = 'https://'+domainName+'.bookingkoala.com';
}
export const environment: any = {
   production: false,
	hmr: true,
	appVersion: 'media-preview-1.0.0',
	baseUrl: baseUrl,
	imgBase: bkcdn,
};